module.exports = __webpack_public_path__ + "static/media/attack-number-2.578d6333.png";